import IcLocationVF from './IcLocationVF'
export default IcLocationVF
